import _export from '../internals/export.js';
import mathExpm1 from '../internals/math-expm1.js';

var $ = _export;
var expm1 = mathExpm1; // eslint-disable-next-line es/no-math-cosh -- required for testing

var $cosh = Math.cosh;
var abs = Math.abs;
var E = Math.E; // `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh

$({
  target: 'Math',
  stat: true,
  forced: !$cosh || $cosh(710) === Infinity
}, {
  cosh: function cosh(x) {
    var t = expm1(abs(x) - 1) + 1;
    return (t + 1 / (t * E * E)) * (E / 2);
  }
});
